import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "types/store";
import styles from "components/LanguageModelArtifact/style.module.css";
import { Button } from "aible";
import * as reportReducer from "containers/Report/ReportReducer";
import * as ChatDetailsReducer from "containers/ChatDetails/reducer";
import * as globalReducer from "containers/App/reducer";
import * as contentGenerationReducer from "containers/ContentGeneration/reducer";
import * as viewReducer from "containers/View/reducer";
import { AutoSizer, Table, Column, SortDirection } from "react-virtualized";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { getSelectedFolder } from "containers/Folders/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { getChatApp } from "containers/ChatGPT/reducer";
import MarkdownPanel from "components/ChatGPT/MarkdownPanel";
import * as chatAppReducer from "containers/ChatApp/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import Toggle from "components/Inputs/Toggle/Toggle";
import { LineInput } from "components/Inputs/LineInput";
import { getNumericComparator, getStringComparator, keysOf, reverseOrder } from "utils/collect";
import * as nextReducer from "@/containers/Next/NextReducer";
import { FEEDBACK_BREAKPOINTS } from "@/containers/LanguageModelArtifact/reducer";
import ModelSelector from "@/components/ChatGPT/ModelSelector";
const CreateTrainingDataModal = ({ showModal, updateShowModal, initialReport, onComplete, currentView, updateCurrentView, templateName, synthDataCount, dataGenerationModelId }) => {
    const dispatch = useDispatch();
    const initialSelectedReport = initialReport ? { [initialReport]: true } : {};
    const [selectedReports, updateSelectedReports] = useState(initialSelectedReport);
    const [selectedResponses, updateSelectedResponses] = useState({});
    const [sortBy, updateSortBy] = useState("creationDate");
    const [sortDirection, updateSortDirection] = useState(SortDirection.DESC);
    const [isCreatingData, updateIsCreatingData] = useState(false);
    const [isLoadingResponses, updateIsLoadingResponses] = useState(false);
    const [isFirstOpened, updateIsFirstOpened] = useState(false);
    const [localCreateSynthData, updateLocalCreateSynthData] = useState(false);
    const [localDataGenerationModelId, updateLocalDataGenerationModelId] = useState();
    const [localSynthDataCount, updateLocalSynthDataCount] = useState(FEEDBACK_BREAKPOINTS.MIN);
    const isReportsLoading = useSelector((state) => globalReducer.getIsReportsLoading(state));
    const folderId = useSelector((state) => getSelectedFolder(state));
    const chatApp = useSelector((state) => getChatApp(state));
    useEffect(() => {
        if (!isFirstOpened && showModal) {
            /*
            TODO: Not sure what's this for, can we remove this? I've set forceUpdateReports=true here to force an update
            and not a replace of the updateBase call in the reportReducer, since when we open this modal on a report
            that isn't in the inital load (a report loaded after clicking Show More), then this call wipes out the report
            we are looking at the reload all of the first paginated reports.
            */
            dispatch(reportReducer.initFromStorage(undefined, true, undefined, true, true));
            updateIsFirstOpened(true);
        }
    }, [showModal]);
    useEffect(() => {
        if (initialReport) {
            const updatedReports = {
                ...selectedReports,
                [initialReport]: true
            };
            updateSelectedReports(updatedReports);
        }
    }, [initialReport]);
    useEffect(() => {
        if (synthDataCount !== undefined) {
            let newCreateSynthData = synthDataCount > 0;
            if (localCreateSynthData !== newCreateSynthData) {
                updateLocalCreateSynthData(newCreateSynthData);
            }
            if (synthDataCount !== localSynthDataCount) {
                updateLocalSynthDataCount(synthDataCount);
            }
        }
    }, [synthDataCount]);
    const toggleReportSelection = (id) => {
        const updatedReports = {
            ...selectedReports,
            [id]: !selectedReports[id]
        };
        return updateSelectedReports(updatedReports);
    };
    const toggleResponseSelection = (id) => {
        const updatedResponses = {
            ...selectedResponses,
            [id]: !selectedResponses[id]
        };
        return updateSelectedResponses(updatedResponses);
    };
    const reportData = useSelector((state) => chatGPTReducer.getAllConversationResultsWithFeedback(state, ["LIKE"]));
    const retSynthDataCount = synthDataCount ? synthDataCount : localCreateSynthData ? localSynthDataCount : 0;
    const retDataGenerationModel = dataGenerationModelId ?? localDataGenerationModelId;
    const handleViewResponses = async () => {
        const selReports = Object.keys(selectedReports).filter((report) => selectedReports[report]);
        updateIsLoadingResponses(true);
        try {
            const promises = [];
            selReports.forEach((reportId) => {
                const reportsData = reportData.find((report) => report?.id === Number(reportId));
                if (reportsData == undefined) {
                    return;
                }
                const reportAccounts = keysOf(reportsData.chatDetails);
                reportAccounts?.forEach((account, index) => {
                    reportsData.chatDetails[account].forEach((id) => {
                        const chatDetail = dispatch(ChatDetailsReducer.getChatMessageDetailById(id));
                        if (!(chatDetail && chatDetail?.reportId)) {
                            const currPromise = dispatch(ChatDetailsReducer.fetchChatMessageDetails(id, Number(reportAccounts[index]))).then((details) => {
                                const newDetails = {
                                    ...details,
                                    reportId: Number(reportId)
                                };
                                dispatch(ChatDetailsReducer.updateChatMessageDetails(id, newDetails));
                            });
                            promises.push(currPromise);
                        }
                    });
                });
            });
            return Promise.all(promises).then(() => {
                return;
            });
        }
        catch {
            updateIsLoadingResponses(false);
        }
        finally {
            updateIsLoadingResponses(false);
        }
    };
    const handleCreateTrainingDataset = async () => {
        updateIsCreatingData(true);
        console.log("Creating new dataset");
        const selectedExecutions = Object.keys(selectedResponses).filter((id) => selectedResponses[id]);
        const currentDate = new Date().toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
        const trainingDataName = "New Training Data - " + currentDate;
        const exampleSetCreate = {
            name: trainingDataName,
            description: "",
            metadata: {},
            folder_id: folderId
        };
        const newExampleset = await dispatch(contentGenerationReducer.createExampleSet(exampleSetCreate));
        console.log("Created example set: ", newExampleset);
        console.log("Adding examples to example set: ", selectedExecutions, newExampleset);
        dispatch(contentGenerationReducer.addExecutionsToExampleSet(newExampleset?.id, selectedExecutions)).finally(async () => {
            try {
                if (retSynthDataCount > 0 && retDataGenerationModel) {
                    await dispatch(contentGenerationReducer.addSyntheticDataToExampleSet(newExampleset?.id, retDataGenerationModel, retSynthDataCount));
                }
            }
            catch (e) { }
            try {
                if (chatApp?.id && newExampleset?.id) {
                    await dispatch(chatAppReducer.addTrainingDatasetToChatApp(chatApp.id, newExampleset.id));
                }
            }
            catch (e) {
                console.log(e);
            }
            updateShowModal(false);
            updateCurrentView("reports");
            if (onComplete) {
                const newModel = await dispatch(nextReducer.handleTrainFineTuning(undefined, newExampleset));
                onComplete();
            }
            return updateIsCreatingData(false);
        });
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => {
            updateShowModal(false);
            updateCurrentView("reports");
        } },
        React.createElement(DialogContent, { size: "xl" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Review and Confirm Post Training Data")),
            React.createElement(React.Fragment, null,
                currentView === "reports" && (React.createElement(ReportsDataTable, { isReportsLoading: isReportsLoading, selectedReports: selectedReports, sortBy: sortBy, updateSortBy: updateSortBy, sortDirection: sortDirection, updateSortDirection: updateSortDirection, reportData: reportData, toggleReportSelection: toggleReportSelection })),
                currentView === "responses" && (React.createElement(React.Fragment, null,
                    React.createElement(ResponsesDataTable, { selectedResponses: selectedResponses, selectedReports: selectedReports, handleViewResponses: handleViewResponses, toggleResponseSelection: toggleResponseSelection, updateSelectedResponses: updateSelectedResponses, isLoadingResponses: isLoadingResponses, templateName: templateName }),
                    synthDataCount === undefined ? (React.createElement("div", null,
                        React.createElement("div", { className: styles.synthDataText, style: { marginBottom: "6px" } },
                            React.createElement(Toggle, { checked: localCreateSynthData, onChange: () => {
                                    updateLocalCreateSynthData(!localCreateSynthData);
                                }, isAibleColors: true }),
                            React.createElement("div", { style: { marginLeft: "6px" } },
                                React.createElement("strong", null, "Add synthetic data? "),
                                React.createElement("span", null, "This data will be based off your current feedback"))),
                        localCreateSynthData ? (React.createElement("div", { className: styles.synthDataText, style: { height: "31px" } },
                            React.createElement("div", null, "Create"),
                            React.createElement("div", { style: { width: "100px", margin: "0px 6px" } },
                                React.createElement(LineInput, { value: localSynthDataCount, onChange: (v) => {
                                        updateLocalSynthDataCount(Number(v) || 0);
                                    } })),
                            React.createElement("div", null, "additional rows of synthetic data"))) : (React.createElement("div", { style: { height: "31px" } })),
                        localCreateSynthData ? (React.createElement("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                marginBottom: "10px",
                                justifyContent: "space-between"
                            } },
                            React.createElement("div", null, "Model for Data Generation"),
                            React.createElement("div", null,
                                React.createElement(ModelSelector, { modelId: localDataGenerationModelId, updateModelId: updateLocalDataGenerationModelId, hideIcons: true, isCreatable: true, selectorStyle: {
                                        minWidth: "159px"
                                    }, forceModelId: true, menuPlacement: "top" })))) : (React.createElement("div", { style: { height: "31px" } })))) : synthDataCount && synthDataCount > 0 ? (React.createElement("div", null, `${synthDataCount} additional rows of data will be automatically generated.`)) : null))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { onClick: () => {
                        if (currentView === "reports") {
                            updateShowModal(false);
                            if (initialReport) {
                                updateSelectedReports({ [initialReport]: true });
                            }
                            else {
                                updateSelectedReports({});
                            }
                            updateSelectedResponses({});
                        }
                        else {
                            updateCurrentView("reports");
                        }
                    } }, currentView === "reports" ? "Cancel" : "Back"),
                React.createElement(Button, { onClick: () => {
                        if (currentView === "reports") {
                            updateCurrentView("responses");
                            // handleViewResponses();
                        }
                        if (currentView === "responses") {
                            handleCreateTrainingDataset();
                        }
                    }, disabled: (currentView === "reports" && !(Object.keys(selectedReports)?.length > 0)) ||
                        (currentView === "responses" &&
                            !(Object.keys(selectedResponses)?.length > 0) &&
                            Boolean(!localCreateSynthData || retDataGenerationModel)), isLoading: isCreatingData }, currentView === "reports"
                    ? "View Responses from Selected Projects"
                    : "Create Post Train and Evaluator Dataset")))));
};
const ReportsDataTable = ({ isReportsLoading, selectedReports, toggleReportSelection, sortBy, updateSortBy, sortDirection, updateSortDirection, reportData }) => {
    const dispatch = useDispatch();
    const columns = [
        { label: "Selected", dataKey: "id", width: 100 },
        { label: "Project Name", dataKey: "projectName", width: 500 },
        // Now showing total liked responses instead
        { label: "Total Liked Responses", dataKey: "totalFeedback", width: 800 },
        { label: "Date Created", dataKey: "creationDate", width: 300 }
    ];
    const [sortedData, updateSortedData] = useState([]);
    const getSortFunction = (sortBy) => {
        switch (sortBy) {
            case "totalFeedback":
            case "id":
                return getNumericComparator((x) => x[sortBy]);
            case "creationDate":
                return getNumericComparator((x) => Date.parse(x[sortBy]));
            case "projectName":
                return getStringComparator((x) => x[sortBy]);
            default:
                return getNumericComparator(() => 0);
        }
    };
    const sort = ({ sortBy, sortDirection }) => {
        const sortFunc = getSortFunction(sortBy);
        updateSortBy(sortBy);
        updateSortDirection(sortDirection);
        updateSortedData(reportData.toSorted(sortDirection === SortDirection.ASC ? sortFunc : reverseOrder(sortFunc)));
    };
    useEffect(() => {
        if (!isReportsLoading) {
            sort({ sortBy, sortDirection });
        }
    }, [isReportsLoading]);
    const handleRowClick = ({ rowData }) => {
        if (rowData?.totalFeedback > 0) {
            toggleReportSelection(rowData?.id);
        }
    };
    return (React.createElement("div", null,
        sortedData.length > 0 && (React.createElement("div", { style: { height: "400px" } },
            React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(Table, { width: width, height: height, headerHeight: 30, rowHeight: 44, rowCount: sortedData?.length, rowGetter: ({ index }) => sortedData[index], sort: sort, sortBy: sortBy, sortDirection: sortDirection, rowClassName: styles.responseDataRow, className: undefined, headerClassName: styles.responseDataColumn, onRowClick: handleRowClick }, columns.map((column, index) => {
                if (column.dataKey === "id") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ rowData }) => (React.createElement("div", { style: { paddingLeft: "20px" } },
                            React.createElement("input", { type: "checkbox", style: { marginRight: "10px", marginBottom: "2px" }, checked: selectedReports[rowData?.id] === true, readOnly: true, disabled: rowData?.totalFeedback <= 0 }))), className: styles.responseDataColumn }));
                }
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.responseDataColumn }));
            })))))),
        isReportsLoading ? (React.createElement(LoadingIndicator, null)) : (React.createElement("div", { style: { width: "100%", display: "flex", justifyContent: "center", padding: "10px" } },
            React.createElement(Button, { onClick: () => {
                    dispatch(reportReducer.fetchNextReports(true, true));
                } }, "Show More")))));
};
const ResponsesDataTable = ({ selectedResponses, toggleResponseSelection, selectedReports, handleViewResponses, updateSelectedResponses, isLoadingResponses, templateName }) => {
    const columns = [
        { label: "", dataKey: "id", width: 50 },
        { label: "Query", dataKey: "query", width: 500 },
        { label: "Response", dataKey: "response", width: 600 },
        { label: "Project Name", dataKey: "projectName", width: 260 },
        { label: "Model", dataKey: "modelId", width: 160 },
        { label: "Data", dataKey: "resultData", width: 180 }
    ];
    const selReports = Object.keys(selectedReports)
        .filter((report) => selectedReports[report])
        .map((rId) => (isNaN(Number(rId)) ? rId : Number(rId)));
    // Only use liked details
    // const reportDetails = useSelector((state) => ChatDetailsReducer.getDetailsForReports(state, selReports));
    const likedDetails = useSelector((state) => ChatDetailsReducer.getLikedDetailsForReports(state, selReports));
    const responseData = useSelector((state) => ChatDetailsReducer.getLikedResponsesFromSelectedReports(state, selReports, templateName));
    const handleRowClick = ({ rowData }) => {
        return toggleResponseSelection(rowData?.id);
    };
    useEffect(() => {
        handleViewResponses();
    }, []);
    useEffect(() => {
        if (!isLoadingResponses) {
            console.log("Selecting all responses", responseData, likedDetails);
            updateSelectedResponses((prevSelectedItems) => {
                const updatedResponses = { ...prevSelectedItems };
                responseData.forEach((response) => {
                    updatedResponses[response.id] = true;
                });
                return updatedResponses;
            });
        }
    }, [isLoadingResponses]);
    if (isLoadingResponses) {
        return (React.createElement("div", null,
            React.createElement(LoadingIndicator, null)));
    }
    return (React.createElement("div", null,
        React.createElement("div", { style: { height: "500px" } },
            React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(Table, { width: width, height: height, headerHeight: 30, rowHeight: 180, rowCount: responseData?.length, rowGetter: ({ index }) => responseData[index], rowClassName: styles.responseDataRow, className: undefined, headerClassName: styles.responseDataColumn, onRowClick: handleRowClick }, columns.map((column, index) => {
                if (column.dataKey === "id") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ rowData }) => (React.createElement("div", { style: { paddingLeft: "6px" } },
                            React.createElement("input", { type: "checkbox", style: { marginBottom: "2px" }, checked: selectedResponses[rowData?.id] === true, readOnly: true }))), className: styles.responseDataColumn }));
                }
                if (column.dataKey === "response" ||
                    column.dataKey === "query" ||
                    column.dataKey === "projectName" ||
                    column.dataKey === "modelId") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ cellData }) => (React.createElement("div", { className: styles.responseDataResponseCell },
                            React.createElement(MarkdownPanel, null, cellData))), className: styles.responseDataColumn }));
                }
                if (column.dataKey === "resultData") {
                    return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, cellRenderer: ({ cellData }) => (React.createElement("div", { className: styles.responseDataResponseCell },
                            React.createElement(DatasetsList, { dataList: cellData.datasets, type: "datasets" }),
                            React.createElement(DatasetsList, { dataList: cellData.artifacts, type: "artifacts" }))), className: styles.responseDataColumn }));
                }
                return (React.createElement(Column, { key: index, label: column.label, dataKey: column.dataKey, width: column.width, className: styles.responseDataColumn }));
            })))))));
};
const DatasetsList = ({ dataList, type }) => {
    const datasets = useSelector((state) => viewReducer.getDatasets(state, undefined, undefined, true)) ?? [];
    const corpusList = useSelector((state) => viewReducer.getCorpusList(state, true)) ?? [];
    const results = dataList.map((item) => {
        if (type === "datasets") {
            const foundDataset = datasets.find((d) => d.id === item);
            return foundDataset?.name;
        }
        if (type === "artifacts") {
            const foundArtifact = corpusList.find((c) => c.id === item);
            return foundArtifact?.name;
        }
    });
    return React.createElement("div", null, results);
};
export default CreateTrainingDataModal;
